import { mainLogger as log } from "@/app/logger"
import { IS_SERVER } from "@/app/types"

// this returns a function that will install a 'keydown' handler, and returns a cleanup function
// usage: useEffect(getEscHandler(...))
export function getEscHandler(handler: Function) {
  log.trace("Returning a function to create a new ESC handler")
  return () => {
    log.trace("Creating ESC handler")
    if (IS_SERVER()) return // do nothing
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        log.trace("ESC detected")
        handler()
      }
    }
    if (window && window.addEventListener) {
      window.addEventListener("keydown", handleEsc)
      log.trace("Added ESC handler to window[keydown]")
    }
    // return a cleanup function
    return () => {
      if (window && window.removeEventListener) {
        window.removeEventListener("keydown", handleEsc)
        log.trace("Removed ESC handler to window[keydown]")
      }
    }
  }
}
